import { css } from 'lit';

export const styles = css`
  :host { display: block; }

  .asset-info { display: flex; align-items: center; gap: 1rem; margin-bottom: 1.5rem; }

  .asset-image-placeholder {
    width: 80px; height: 80px; background: var(--sl-color-neutral-200); border-radius: 8px;
    display: flex; align-items: center; justify-content: center; border: 2px dashed var(--sl-color-neutral-300);
    cursor: pointer; transition: all .2s ease; position: relative;
  }
  .asset-image-placeholder:hover { background: var(--sl-color-neutral-100); border-color: var(--sl-color-primary-400); }
  .asset-image-placeholder.uploading { border-color: var(--sl-color-primary-600); background: var(--sl-color-primary-50); }
  .asset-image-placeholder img { width: 100%; height: 100%; object-fit: cover; border-radius: 6px; }

  .upload-overlay { position: absolute; inset: 0; background: rgba(0,0,0,.7); display:flex; align-items:center; justify-content:center; border-radius:6px; opacity:0; transition:opacity .2s ease; }
  .asset-image-placeholder:hover .upload-overlay { opacity: 1; }
  .upload-overlay sl-icon { color: white; font-size: 1.5rem; }

  .asset-details { flex: 1; }
  .asset-name { font-size: 1.25rem; font-weight: 600; margin-bottom: .25rem; color: var(--sl-color-neutral-900); }
  .asset-location { font-size: .875rem; color: var(--sl-color-neutral-600); }

  
  .header-qr-code {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    
  }

  /* Shoelace tab group styling */
  sl-tab-group {
    margin: 0 -1.5rem 1.5rem;
  }

  .info-description { color:var(--sl-color-neutral-600); margin-bottom:1.5rem; font-size:.875rem; }

  .field-row { display:flex; align-items:center; gap:1rem; margin-bottom:1rem; padding:.75rem; background:var(--sl-color-neutral-50); border-radius:8px; }
  .field-label { min-width:120px; font-weight:600; color:var(--sl-color-neutral-700); }
  .field-value { flex:1; display:flex; align-items:center; gap:.5rem; }
  .field-value sl-input, .field-value sl-select { flex:1; min-width:200px; }

  .dialog-footer { display:flex; justify-content:flex-end; align-items:center; gap:.75rem; }
  sl-dialog { --width: 900px; }
  

  /* Simple table styles for WOs tab */
  .data-table-container { overflow-x: auto; }
  .data-table { width: 100%; border-collapse: collapse; }
  .data-table th, .data-table td { padding: 0.5rem 0.75rem; text-align: left; border-bottom: 1px solid var(--sl-color-neutral-200); }
  .data-table th { font-weight: 600; color: var(--sl-color-neutral-600); font-size: 0.9rem; }
  .data-table td { color: var(--sl-color-neutral-900); font-size: 0.9rem; }
`;
